import React from "react";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Container, Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { AuthProvider, useAuth } from "./authContext";

import "./custom.scss";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from "./components/pages/LoginPage/LoginPage";
import MaturaApplicationPage from "./components/pages/MaturaApplicationPage/MaturaApplicationPage";
import MaturaApplicationSentPage from "./components/pages/MaturaApplicationSentPage/MaturaApplicationSentPage";
import SideBar from "./components/SideBar/SideBar";
import RootComponent from "./components/RootComponent/RootComponent";
import InstructorsPage from "./components/pages/InstructorsPage/InstructorsPage";
import MobileNavbar from "./components/MobileNavbar/MobileNavbar";
import AboutPage from "./components/pages/AboutPage/AboutPage";
import HomePage from "./components/pages/HomePage/HomePage";
import SubjectsPage from "./components/pages/SubjectsPage/SubjectsPage";
import InstructorAdminListPage from "./components/pages/InstructorsAdmin/InstructorAdminListPage/InstructorAdminListPage";
import InstructorAddEditPage from "./components/pages/InstructorsAdmin/InstructorAddEditPage/InstructorAddEditPage";
import CourseAddEditPage from "./components/pages/Coursees/CourseAddPage/CourseAddEditPage";
import CoursesAdminListPage from "./components/pages/Coursees/CoursesAdminListPage/CoursesAdminListPage";
import CoursePage from "./components/pages/Coursees/CoursePage/CoursePage";
import PricePage from "./components/pages/PricePage/PricePage";
import MaturaApplicaitonsListPage from "./components/pages/MaturaApplicationsListPage/MaturaApplicaitonsListPage";
import DashboardPage from "./components/pages/DashboardPage/DashboardPage";
import PasswordSetupPage from "./components/pages/PasswordSetupPage/PasswordSetupPage";

const RequireRouteAccess = ({ allowedAccess }: { allowedAccess: string[] }) => {
  const { userProfile } = useAuth();
  const location = useLocation();
  return userProfile && allowedAccess.includes(userProfile.role) ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

function App() {
  return (
    <AuthProvider>
      <RootComponent>
        <BrowserRouter>
          <SideBar />
          <div id="wrapper" style={{ overflow: "auto", width: "100%" }}>
            <MobileNavbar />
            <Container>
              <Row className="justify-content mt-3">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/cjenik" element={<PricePage />} />
                  <Route path="/prijava" element={<LoginPage />} />
                  <Route
                    path="/prijava-pripreme-drzavna-matura"
                    element={<MaturaApplicationPage />}
                  />
                  <Route
                    path="/prijava-uspjesno-poslana"
                    element={<MaturaApplicationSentPage />}
                  />
                  <Route path="/nastavnici" element={<InstructorsPage />} />
                  <Route path="/o-nama" element={<AboutPage />} />
                  <Route path="/grupa/:id" element={<CoursePage />} />

                  <Route path="/dashboard" element={<DashboardPage />} />

                  <Route
                    path="/accounts/activate"
                    element={<PasswordSetupPage />}
                  />

                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/prijave"
                      element={<MaturaApplicaitonsListPage />}
                    />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route path="/predmeti" element={<SubjectsPage />} />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/nastavnici-admin"
                      element={<InstructorAdminListPage />}
                    />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/dodaj-nastavnika"
                      element={<InstructorAddEditPage />}
                    />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/nastavnici-admin/:id"
                      element={<InstructorAddEditPage />}
                    />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/dodaj-grupu"
                      element={<CourseAddEditPage />}
                    />
                  </Route>
                  <Route
                    element={
                      <RequireRouteAccess
                        allowedAccess={["CLERK", "PRINCIPAL"]}
                      />
                    }
                  >
                    <Route
                      path="/grupe-admin"
                      element={<CoursesAdminListPage />}
                    />
                    <Route
                      path="/grupe-admin/edit/:courseId?"
                      element={<CourseAddEditPage />}
                    />
                  </Route>
                </Routes>
              </Row>
            </Container>
          </div>
        </BrowserRouter>
        <ToastContainer />
      </RootComponent>
    </AuthProvider>
  );
}

export default App;
